<template>
  <v-container grid-list-md class="data-card-container" :class="{'px-0': $vuetify.breakpoint.smAndDown}">
      <v-card :class="['card data-card item ma-2', lists.className]" :elevation="2">
          <v-img
            class="card-thumb"
            :src=lists.dataImage
          />
          <v-card-title>
            {{ lists.dataIcon }}
            {{ lists.dataTitle }}
          </v-card-title>
          <v-card-text>
            <div v-show="$vuetify.breakpoint.xs">
              <v-flex text-xs-left
                class="data-row data-row-xs"
                v-for="(item, name, index) in lists.dataValues"
                :key="index"
              >
                  <div class="header label1">{{ lists.dataHeadings[0].Label1 }}</div>
                  <div class="data val1">{{ item.val1 }}</div>
                  <div class="header label2">{{ lists.dataHeadings[0].Label2 }}</div>
                  <div class="data val2">{{ item.val2 }}</div>
                  <div class="header label3">{{ lists.dataHeadings[0].Label3 }}</div>
                  <div class="data val3">{{ item.val3 }}</div>
                  <div class="header label4">{{ lists.dataHeadings[0].Label4 }}</div>
                  <div class="data val4">{{ item.val4 }}</div>
              </v-flex>
            </div>
            <div v-show="$vuetify.breakpoint.smAndUp">
              <v-flex text-xs-left
                  v-for="(item, name, index) in lists.dataHeadings"
                  :key="index"
              >
                <div class="column-heading">
                  <div class="header label1">{{ item.Label1 }}</div>
                  <div class="header label2">{{ item.Label2 }}</div>
                  <div class="header label3">{{ item.Label3 }}</div>
                  <div class="header label4">{{ item.Label4 }}</div>
                </div>
              </v-flex>
                  
              <v-flex text-xs-left
                class="data-row"
                v-for="(item, name, index) in lists.dataValues"
                :key="index"
              >
                  <div class="data val1">{{ item.val1 }}</div>
                  <div class="data val2">{{ item.val2 }}</div>
                  <div class="data val3">{{ item.val3 }}</div>
                  <div class="data val4">{{ item.val4 }}</div>
              </v-flex>
            </div>
          </v-card-text>
      </v-card>
   </v-container>
</template>

<script>
import lozad from 'lozad'

export default {
  name: 'DataCards',
  props: ['lists'],
  data () {
    return {
      loading: false
    }
  },
  methods: {
    loadImages () {
      const observer = lozad('.lozad', {
          rootMargin: '100px 0px', // like css margin
          // threshold: 0.1 // ratio of element convergence
          loaded: function(el) {
              // Custom implementation on a loaded element
              el.classList.add('loaded');
              // el.classList.remove('loading-blur');
          }
      });

      observer.observe();
    }
  },
  computed: {
    flex () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 12
        case 'sm': return 6
        case 'md': return 4
        case 'lg': return 3
        case 'xl': return 3
        default: return 3
      }
    }
  },
  mounted () {
    this.loadImages()
    // eslint-disable-next-line no-console
    console.log(this.lists);
  },
}
</script>

<style lang="scss" scoped>
  .data-card {
    height: 100%;
    max-height: 500px;
    overflow-y: scroll;

    .v-card__title {
      padding-left: 16px;
      padding-bottom: 0;
    }
    
  }

  .column-heading, .data-row {
    display: flex;

      .header {
        flex: 0 0 25%;
        font-weight: 700;

        &.right {
          text-align: right;
        }
      }

      .data {
        flex: 0 0 25%;

        &.right {
          text-align: right;
        }
      }

  }

  .data-row-xs {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      border-top: 1px solid #ddd;

      .header {
        flex: 0 0 40%;
      }
      .data {
        flex: 0 0 60%;
      }
    }



</style>
